export default function Contact() {
  return (
    <section className="py-20 bg-gradient-to-br from-blue-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-blue-900 mb-4">
            Contacto y Ubicación
          </h2>
          <div className="w-20 h-1 bg-blue-600 mx-auto mb-4"></div>
          <p className="text-base text-gray-600 max-w-2xl mx-auto">
            Estamos ubicados en Rawson 1006 en el centro de Mar del Plata. Visitanos o contactanos para solicitar tu turno
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-12">
          <div>
            <div className="bg-white rounded-xl shadow-lg p-8 mb-8">
              <h3 className="text-xl font-bold text-gray-900 mb-6">Información de Contacto</h3>
              
              <div className="space-y-6">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="ri-map-pin-line text-xl text-blue-600"></i>
                  </div>
                  <div>
                    <h4 className="text-sm font-bold text-gray-900 mb-1">Dirección</h4>
                    <p className="text-sm text-gray-700">Rawson 1006</p>
                    <p className="text-sm text-gray-700">Mar del Plata, Provincia de Buenos Aires</p>
                    <p className="text-sm text-gray-700">Argentina</p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="ri-phone-line text-xl text-blue-600"></i>
                  </div>
                  <div>
                    <h4 className="text-sm font-bold text-gray-900 mb-1">Teléfono</h4>
                    <a 
                      href="tel:+542234515475" 
                      className="text-sm text-blue-600 hover:text-blue-700 font-medium cursor-pointer"
                    >
                      0223 451-5475
                    </a>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="ri-whatsapp-line text-xl text-green-600"></i>
                  </div>
                  <div>
                    <h4 className="text-sm font-bold text-gray-900 mb-1">WhatsApp</h4>
                    <a 
                      href="https://wa.me/5492235470285" 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="text-sm text-green-600 hover:text-green-700 font-medium cursor-pointer"
                    >
                      223-547-0285
                    </a>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="ri-time-line text-xl text-blue-600"></i>
                  </div>
                  <div>
                    <h4 className="text-sm font-bold text-gray-900 mb-2">Horario de Verano</h4>
                    <div className="space-y-1">
                      <p className="text-sm text-gray-700">Lunes a Viernes: 9:00 - 15:00</p>
                      <p className="text-sm text-gray-500">Sábados y Domingos: Cerrado</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row gap-4">
              <a 
                href="tel:+542234515475" 
                className="flex-1 inline-flex items-center justify-center gap-2 bg-blue-600 text-white px-6 py-4 rounded-lg text-base font-semibold hover:bg-blue-700 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-phone-line text-xl"></i>
                Llamar para Turno
              </a>
              <a 
                href="https://wa.me/5492235470285" 
                target="_blank" 
                rel="noopener noreferrer"
                className="flex-1 inline-flex items-center justify-center gap-2 bg-green-600 text-white px-6 py-4 rounded-lg text-base font-semibold hover:bg-green-700 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-whatsapp-line text-xl"></i>
                WhatsApp
              </a>
            </div>
          </div>

          <div>
            <div className="bg-white rounded-xl shadow-lg overflow-hidden h-full">
              <iframe 
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3143.8!2d-57.5569!3d-38.0055!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x9584dc3b!2sRawson+1006%2C+Mar+del+Plata%2C+Buenos+Aires!5e0!3m2!1ses!2sar!4v1234567890" 
                width="100%" 
                height="100%" 
                style={{ border: 0, minHeight: '500px' }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Ubicación ICM Instituto de Clínica Médica - Rawson 1006"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}